import React from 'react';
import envConfig from '@nile/home/src/Config/env';

function NestedEmptyState(props) {
  const { message } = props;
  return (
    <div className="flex flex-align-center flex-justify-center full-height full-width">
      <div className="flex-row flex-align-center">
        <div className="flex-item-fixed">
          <img
            alt="Empty state"
            className="w100px mr-40 h100"
            src={`${envConfig.imageRoot}svg/policy-empty-state.svg`}
          />
        </div>
        <div className="flex-item-fixed empty-state">
          {message ? message : 'No data found'}
        </div>
      </div>
    </div>
  );
}

export default NestedEmptyState;
